import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, Disc3 } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-4" data-testid="not-found-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="text-center">
        <div className="flex justify-center mb-6">
          <span className="vinyl-spin inline-flex w-24 h-24 rounded-full bg-ink border-[3px] border-ink items-center justify-center">
            <span className="w-10 h-10 rounded-full bg-pink border-2 border-cream flex items-center justify-center">
              <Disc3 size={18} className="text-cream" />
            </span>
          </span>
        </div>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-pink font-semibold">Off the record</p>
        <h1 className="mt-3 font-display font-bold text-6xl sm:text-7xl" data-testid="not-found-heading">404</h1>
        <p className="mt-3 text-plum font-medium max-w-sm mx-auto">
          This page skipped a beat — it doesn't exist. Let's get you back to the music.
        </p>
        <Link to="/" data-testid="not-found-home-link"
          className="btn-pop mt-8 inline-flex items-center gap-2 rounded-full bg-pink text-white font-head font-bold px-8 py-3.5 text-sm border-2 border-ink shadow-[4px_4px_0_#2D1A32]">
          <Home size={15} /> Back to Homepage
        </Link>
      </motion.div>
    </div>
  );
}
